import React from "react";

export const ChevronDownIcon = () => (
  <svg
    width="9"
    height="5"
    viewBox="0 0 9 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M8 0.5L4.25 4.25L0.5 0.499999"
      stroke="#B0B0B0"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronRightIcon = () => (
  <svg
    width="5"
    height="9"
    viewBox="0 0 5 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M0.5 0.5L4.25 4.25L0.5 8"
      stroke="#B0B0B0"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FileIcon = () => (
  <svg
    width="11"
    height="14"
    viewBox="0 0 11 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M10.5 8.5V6.75C10.5 5.50736 9.49264 4.5 8.25 4.5H7.25C6.83579 4.5 6.5 4.16421 6.5 3.75V2.75C6.5 1.50736 5.49264 0.5 4.25 0.5H3M4.5 0.5H1.25C0.835786 0.5 0.5 0.835786 0.5 1.25V12.75C0.5 13.1642 0.835786 13.5 1.25 13.5H9.75C10.1642 13.5 10.5 13.1642 10.5 12.75V6.5C10.5 3.18629 7.81371 0.5 4.5 0.5Z"
      stroke="#6D6D6D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FileActiveIcon = () => (
  <svg
    width="11"
    height="14"
    viewBox="0 0 11 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M1.25 0C0.559644 0 0 0.559644 0 1.25V12.75C0 13.4404 0.559644 14 1.25 14H9.75C10.4404 14 11 13.4404 11 12.75V7.5C11 6.11929 9.88071 5 8.5 5H7.25C6.55964 5 6 4.44036 6 3.75V2.5C6 1.11929 4.88071 0 3.5 0H1.25Z"
      fill="#8657F3"
    />
    <path
      d="M6.14746 0.210603C6.67864 0.824319 7 1.62463 7 2.5V3.75C7 3.88807 7.11193 4 7.25 4H8.5C9.37537 4 10.1757 4.32136 10.7894 4.85254C10.1975 2.58658 8.41342 0.802516 6.14746 0.210603Z"
      fill="#8657F3"
    />
  </svg>
);

export const FolderIcon = () => (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M0.5 6.5V6C0.5 5.17157 1.17157 4.5 2 4.5H12C12.8284 4.5 13.5 5.17157 13.5 6V6.5M7.70711 2.20711L6.29289 0.792893C6.10536 0.605357 5.851 0.5 5.58579 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V10C0.5 10.8284 1.17157 11.5 2 11.5H12C12.8284 11.5 13.5 10.8284 13.5 10V4C13.5 3.17157 12.8284 2.5 12 2.5H8.41421C8.149 2.5 7.89464 2.39464 7.70711 2.20711Z"
      stroke="#8657F3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
